export const getOrderRowExpirationByEndTime = (endTime: string) => {
  const expirationDate = new Date(Number(endTime) * 1000);
  const currentDate = new Date();
  const diff = expirationDate.getTime() - currentDate.getTime();

  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const years = Math.floor(days / 365);

  const expirations = [
    [years, 'years'],
    [days, 'days'],
    [hours, 'hours'],
    [minutes, 'minutes'],
  ];

  return (
    expirations.find(([value, _]) => Number(value) > 0)?.join(' ') ?? 'Expired'
  );
};
